import moment from 'moment';

/**
 * @method formatDate
 * @param {Date|Moment|String|Object} date
 * @return {String}
 */
export function formatDate(date) {
  if (!date) {
    return null;
  }

  if (!date._isAMomentObject) {
    date = moment(date);
  }

  return date.format('MM/DD/YYYY');
}

/**
 * @method findOutDefaultRangeBasedOnHistory
 * @param {Date|Moment|String|Object} Object
 * @return {Object}
 */
export function findOutDefaultRangeBasedOnHistory(historyList) {
  //Get the current date in YYYY-MM-DD format
  const currentDate = moment().format('YYYY-MM-DD');
  console.log(currentDate);
  let selectedItem = null;
  //Loop through the history list and check each item
  for (const item of historyList) {
    if (
      moment(currentDate).isSameOrAfter(item.EffectiveDate) &&
      moment(currentDate).isSameOrBefore(item.TerminationDate) &&
      item.TerminationDate != null
    ) {
      selectedItem = item;
      break;
    }
  }

  //if not found take nearest
  if (selectedItem === null) {
    for (const item of historyList) {
      if (moment(currentDate).isSameOrAfter(item.EffectiveDate)) {
        selectedItem = item;
        break;
      }
    }
  }
  //if not found take future one
  if (selectedItem === null) {
    for (const item of historyList) {
      if (moment(currentDate).isSameOrBefore(item.EffectiveDate)) {
        selectedItem = item;
        break;
      }
    }
  }
  return selectedItem;
}

export function findEffectiveDateInPlanYear(sliceOptions, currentDate) {
  const options = sliceOptions.filter((eachSlice) => {
    if (eachSlice.PlanYearDescription !== 'null') {
      const fromDate = eachSlice.fromDate;
      const toDate = eachSlice.toDate;
      if (moment(currentDate).isBetween(fromDate, toDate, 'days', true)) {
        return true;
      }
    } else {
      if (eachSlice.value === moment().year()) {
        return true;
      }
    }
  });
  return options[0];
}

export function makeDatesArrayAsPerNeed(listDates) {
  const output = [];
  for (const obj of listDates) {
    if (obj.PlanYearDescription && obj.PlanYearDescription.includes('-')) {
      const dates = obj.PlanYearDescription.split(' - ');
      //Trim any whitespace from the dates
      const fromDate = dates[0].trim();
      const toDate = dates[1].trim();
      const newObj = { ...obj, fromDate, toDate };
      output.push(newObj);
    } else {
      const fromDate = `${obj.PlanYear}-01-01`;
      const toDate = `${obj.PlanYear}-12-31`;
      obj.PlanYearDescription = `${obj.PlanYear}-01-01 - ${obj.PlanYear}-12-31`;
      const newObj = { ...obj, fromDate, toDate };
      output.push(newObj);
    }
  }
  return output;
}

export function findoutSelectiveRangeBetweenYears(
  listDates,
  selectBenefitYear,
) {
  let result = null; //Initialize result to null
  const currentDates = selectBenefitYear.value.split(' - ');
  const currentDate1 = new Date(currentDates[0]);
  const currentDate2 = new Date(currentDates[1]);
  for (const item of listDates) {
    const fromDate = new Date(item.fromDate);
    const toDate = new Date(item.toDate);
    if (
      currentDate1 >= fromDate &&
      currentDate1 <= toDate &&
      currentDate2 >= fromDate &&
      currentDate2 <= toDate
    ) {
      //Check if both the current dates are in between the from date and to date
      result = item;
      break;
    }
  }
  return result;
}
